<template>
  <div
    class="item"
    :class="data.class"
    @click="handleClick"
    v-b-tooltip="tooltipConfig"
    v-b-tooltip.html="tooltipText"
  >
    {{ data.label }}
  </div>
</template>

<script>
export default {
  name: 'StatusBadge',
  emits: ['action'],
  props: {
    data: { type: Object, required: true }
  },
  computed: {
    tooltipConfig () {
      return this.data.tooltip ? { variant: 'secondary', customClass: 'tooltip-item' } : null
    },
    tooltipText () {
      return this.data.tooltip?.title || null
    }
  },
  methods: {
    handleClick () {
      if (typeof this.data.action === 'function') {
        this.$emit('action')
      }
    }
  }
}
</script>

<style scoped>
.item {
  padding: 8px 16px;
  height: 24px;
  border-radius: 25px;
  text-align: center;
  font-size: 12px;
  font-family: 'Ubuntu';
  font-weight: 400;
  width: fit-content;
  display: flex;
  align-items: center;
}
.approved { background-color: #C3E6CB; color: #3D5170; }
.invited  { background-color: #DEEBFF; color: #3D5170; cursor: pointer; }
.expired  { background-color: #F8D7DA; color: #3D5170; cursor: pointer; }
.inactive { background-color: #E4E7EE; color: #3D5170; cursor: pointer; }
.pending { background-color: #F8E5AA; color: #3D5170; }

.tooltip-item::v-deep .tooltip-inner {
  white-space: nowrap;
  max-width: max-content;
}
</style>
